import { useSyncExternalStore } from 'react';

const subscribe = () => () => {};
const getSnapshot = () => true;
const getServerSnapshot = () => false;

/**
 * False on the server and during the browser's hydration render; true on every render after that,
 * including the first render of anything mounted after the page has hydrated.
 *
 * Read it before rendering a value that depends on the current time or the browser. A pre-rendered
 * page was built minutes or days before the visit, so such a value differs between the server HTML
 * and the hydration render, and React then discards the whole server HTML and renders the page
 * again in the browser. Render a stable value until this returns true; React renders again with
 * the live value as soon as hydration has finished.
 */
export default function useIsHydrated(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
